<template>
    <WhiteIQOS required :title="$t('integrations.resico_connect.title')" subtitle="true">
        <template #subtitle>
            <!-- <BaseBetaToggle :value="hasResicoIntegration" /> -->
            <span v-if="hasResicoIntegration" class="qrw-label-sm qrw-text-content-success-primary">{{
                $t("integrations.resico_connect.connected")
                }}</span>
            <span v-else class="qrw-label-sm qrw-text-content-error-primary">{{
                $t("integrations.resico_connect.disconnected")
                }}</span>
        </template>

        <div class="gap-row-xs">
            <BaseTextInput size="md" v-model="clientKey" class="w-100" placeholder="Client Key"
                :disabled="hasResicoIntegration" :invalid="!!error" />
            <BaseTextInput size="md" v-model="clientCode" class="w-100" placeholder="Client Code"
                :disabled="hasResicoIntegration" :type="hasResicoIntegration ? 'password' : 'text'"
                :invalid="!!error" />
            <BasePushButton variant="primary" @click="connectIntegration" v-if="!hasResicoIntegration"
                bgColor="background-success-default" textColor="content-base-inverse-primary" size="md">
                {{ $t("integrations.resico_connect.connect") }}
            </BasePushButton>
        </div>

        <InfoModal @close="goToMenus" v-if="askingImportMenu">
            {{ $t("integrations.poster_integration.warning_menu") }}
        </InfoModal>
    </WhiteIQOS>
</template>

<script>
import ResicoAPI from '@/api/resico';

export default {
    data () {
        return {
            clientKey: null,
            clientCode: null,
            error: null,
        }
    },
    methods: {
        connectIntegration () {
            this.error = false
            ResicoAPI.connect(this.cafe._id, this.clientKey, this.clientCode)
                .then(() => {
                    this.$store.dispatch('fetchCafe');
                })
                .catch((error) => {
                    console.error(error);
                    this.error = true
                });
        }
    },
    computed: {
        hasResicoIntegration () {
            return this.$store.getters.hasResicoIntegration;
        },
        cafe () {
            return this.$store.state.cafe;
        }
    },
    mounted () {
        if (this.hasResicoIntegration) {
            this.clientKey = this.cafe.resico.client_key;
            this.clientCode = this.cafe.resico.client_code;
        }
    }
}
</script>